import React, { useContext } from 'react';
import styles from './Nav.module.css';
import { Link } from 'react-scroll';

import DarkModeToggle from './DarkModeToggle';
import { DarkModeContext } from './context/DarkModeContext';
import { SIZE } from './common/constants';

const Nav = () => {
	const { isDarkModeOn } = useContext(DarkModeContext);
	return (
		<div className={styles.nav}>
			<Link
				activeClass='active'
				to='header'
				spy={true}
				smooth={true}
				offset={-70}
				duration={500}
			>
				<div className={styles.logo}></div>
			</Link>

			<ul className={styles.list}>
				<Link
					className={styles.item}
					activeClass='active'
					to='skills'
					spy={true}
					smooth={true}
					offset={-70}
					duration={500}
				>
					Skills
				</Link>
				{/* <Link
					className={styles.item}
					activeClass='active'
					to='projects'
					spy={true}
					smooth={true}
					offset={-70}
					duration={500}
				>
					Projects
				</Link> */}
				<Link
					className={styles.item}
					activeClass='active'
					to='testimonials'
					spy={true}
					smooth={true}
					offset={-70}
					duration={500}
				>
					Testimonials
				</Link>
				<Link
					className={`${styles.item} ${styles.contactMe}`}
					activeClass='active'
					to='contact'
					spy={true}
					smooth={true}
					offset={-70}
					duration={500}
				>
					Contact Me
				</Link>

				{/* <li>
					<a
						href='https://www.linkedin.com/in/wondasom/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<button className={styles.navButton}>LinkedIn</button>
					</a>
				</li> */}
			</ul>
		</div>
	);
};

export default Nav;
